import React, { useState, useEffect } from "react";
import { getStockSummaryRateWise } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import Example from "./calling.js";
import SideBar from "../../sidebar/sideBar";
import Header from "../../header/header";
import { Select } from "antd";

const { Option } = Select;

const StockSummaryRateWise = () => {
  const { user, access_token } = useSelector(authSelector);
  const [itemsQueue, setItemsQueue] = useState([]);
  const [state, setState] = useState({
    enteredOn: "",
    startingDate: "",
  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const clearState = () => {
    setItemsQueue([]);
  };

  const clearFields = () => {
    setState({
      enteredOn: "",
      startingDate: "",
    });
  };

  const editHandler = async (e) => {
    if (!state.startingDate && !state.enteredOn)
      return message.error("Please type date !");
    let data = {
      enteredOn: state.enteredOn,
      startingDate: state.startingDate,
      siteId: Number(user.siteId),
    };

    console.log(data, "ressaaaaa");
    const results = await getStockSummaryRateWise(data, access_token);
    if (results.data.length === 0) {
      message.error("No Record Found in this date");
    }
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            itemCode: Number(curr.itemCode),
            itemName: curr.itemName,
            quantity: curr.quantity,
            rate: curr.rate,
            amount: curr.amount,
            itemDescription: curr.itemDescription,
            printOrder: curr.printOrder,
            siteId: curr.siteId,
          },
        ];
      }, []);
      setItemsQueue(payload);
    } else {
      message.error(results.message);
    }
  };

  return (
    <>
      {itemsQueue.length > 0 ? (
        <>
          <div style={{ backgroundColor: "" }}>
            {itemsQueue.length > 0 && <Example item={itemsQueue}   startingDate={state.startingDate}
                endingDate={state.enteredOn} />}
          </div>
          <div className="pb-3 flex justify-center">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
              onClick={clearState}
            >
              Exit
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="flex  bg-black main">
            <SideBar />
            <div className="h-full  flex flex-col content-center  w-full">
              <Header />
              <div className="flex justify-center mt-10">
                <div className="meterTableMain flex flex-col justify-center w-1/2 ml-10 mt-5 mr-10">
                  <div className="bg-blue-500 headingBox flex justify-center">
                    <h1 className="text-white">Stock Summary Rate Wise</h1>
                  </div>
                  <div className="flex flex-col h-40 content-center items-center justify-items-center justify-evenly">
                    <div className="mt-4">
                      <div className="flex items-center">
                        <label className="text-white" htmlFor="startDate">
                          Starting Date:
                        </label>
                        <input
                          type="date"
                          name="startingDate"
                          className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                          onChange={onChangeText}
                        />
                        <label className="text-white ml-5" htmlFor="endDate">
                          Ending Date:
                        </label>
                        <input
                          type="date"
                          name="enteredOn"
                          className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                          onChange={onChangeText}
                        />
                      </div>
                    </div>
                    <div className="flex items-center">
                      <button
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
                        onClick={editHandler}
                      >
                        View
                      </button>
                      <button
                        onClick={clearFields}
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default StockSummaryRateWise;


// import React, { useState } from "react";
// import { getStockSummaryRateWise } from "../../../api/endpoints/allReports";
// import { authSelector } from "../../../store/selectors/index";
// import { useSelector } from "react-redux";
// import { message } from "antd";
// import Example from "./calling.js";
// import SideBar from "../../sidebar/sideBar";
// import Header from "../../header/header";

// const StockSummaryRateWise = () => {
//   const { user, access_token } = useSelector(authSelector);
//   const [itemsQueue, setItemsQueue] = useState([]);
//   const [state, setState] = useState({
//     enteredOn: "",
//     startingDate: "",
//   });

//   const onChangeText = (e, object) => {
//     if (object) {
//       const { name, value } = object;
//       setState({
//         ...state,
//         [name]: value,
//       });
//     } else {
//       const { name, value } = e.target;
//       setState({
//         ...state,
//         [name]: value,
//       });
//     }
//   };

//   const clearState = () => {
//     setItemsQueue([]);
//   };

//   const clearFields = () => {
//     setState({
//       enteredOn: "",
//       startingDate: "",
//     });
//   };

//   const editHandler = async () => {
//     if (!state.startingDate || !state.enteredOn)
//       return message.error("Please select both dates!");
  
//     const data = {
//       siteId: Number(user.siteId),
//       startDate: state.startingDate,
//       endDate: state.enteredOn,
//     };
  
//     try {
//       const results = await getStockSummaryRateWise(data, access_token);
//       if (results.success && results.data.length > 0) {
//         setItemsQueue(results.data); // <- API response stored here
//       } else {
//         message.error("No Record Found for this date range.");
//       }
//     } catch (error) {
//       console.error("Error fetching stock summary:", error);
//       message.error("Something went wrong.");
//     }
//   };
  

//   return (
//     <>
//       {itemsQueue.length > 0 ? (
//         <>
//           <div>
//             <Example
//               item={itemsQueue}
//               startingDate={state.startingDate}
//               endingDate={state.enteredOn}
//             />
//           </div>
//           <div className="pb-3 flex justify-center">
//             <button
//               className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
//               onClick={clearState}
//             >
//               Exit
//             </button>
//           </div>
//         </>
//       ) : (
//         <>
//           <div className="flex bg-black main">
//             <SideBar />
//             <div className="h-full flex flex-col content-center w-full">
//               <Header />
//               <div className="flex justify-center mt-10">
//                 <div className="meterTableMain flex flex-col justify-center w-1/2 ml-10 mt-5 mr-10">
//                   <div className="bg-blue-500 headingBox flex justify-center">
//                     <h1 className="text-white">Stock Summary Rate Wise</h1>
//                   </div>
//                   <div className="flex flex-col h-40 content-center items-center justify-items-center justify-evenly">
//                     <div className="mt-4">
//                       <div className="flex items-center">
//                         <label className="text-white" htmlFor="startDate">
//                           Starting Date:
//                         </label>
//                         <input
//                           type="date"
//                           name="startingDate"
//                           className="text-black inpTxt p-2 h-8 ml-3 mb-3"
//                           onChange={onChangeText}
//                         />
//                         <label className="text-white ml-5" htmlFor="endDate">
//                           Ending Date:
//                         </label>
//                         <input
//                           type="date"
//                           name="enteredOn"
//                           className="text-black inpTxt p-2 h-8 ml-3 mb-3"
//                           onChange={onChangeText}
//                         />
//                       </div>
//                     </div>
//                     <div className="flex items-center">
//                       <button
//                         className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
//                         onClick={editHandler}
//                       >
//                         View
//                       </button>
//                       <button
//                         onClick={clearFields}
//                         className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
//                       >
//                         Clear
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}
//     </>
//   );
// };

// export default StockSummaryRateWise;
